/**
 * @generated SignedSource<<c9585aefc8f8401e668512c351644656>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type ImageVersionTypeName = "bgProcessed" | "datamatics" | "large" | "master" | "medium" | "oldMaster" | "original" | "placeholder" | "small" | "thumb" | "transparent" | "zoom" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type checkoutSetUpActions_item$data = {
  readonly id: string;
  readonly isPrivateVisibilityType: boolean | null;
  readonly photos: ReadonlyArray<{
    readonly versions: ReadonlyArray<{
      readonly type: {
        readonly name: ImageVersionTypeName | null;
      } | null;
      readonly webPath: string | null;
    } | null> | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTrackingActions_item">;
  readonly " $fragmentType": "checkoutSetUpActions_item";
};
export type checkoutSetUpActions_item$key = {
  readonly " $data"?: checkoutSetUpActions_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutSetUpActions_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutSetUpActions_item"
};

(node as any).hash = "6651e17bfa440319049a7ee4192126af";

export default node;
